export default {
  formatDate(value) {
    if (value) {
      const date = new Date(Date.parse(value.replace(/-/g, '/')));
      let month;
      let day;
      let hours;
      let minutes;
      // 月
      if ((date.getMonth() + 1) >= 10) {
        month = date.getMonth() + 1
      } else {
        month = `0${date.getMonth() + 1}`
      }
      // 日
      if (date.getDate() >= 10) {
        day = date.getDate();
      } else {
        day = `0${date.getDate()}`;
      }
      // 时
      if (date.getHours() >= 10) {
        hours = date.getHours();
      } else {
        hours = `0${date.getHours()}`;
      }
      // 分
      if (date.getMinutes() >= 10) {
        minutes = date.getMinutes();
      } else {
        minutes = `0${date.getMinutes()}`;
      }
      return `${date.getFullYear()}-${month}-${day} ${hours}:${minutes}`;
    }

    return value;
  },
};
